import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel'; // requires a loader
import React, { ReactNode } from 'react';
import marvel from '../../../../assets/images/games/m-game/marvelbg.webp';
type Props = {
    images?: any[];
    onCompleteSlide: (idx: number, item: ReactNode) => void;
};
export default function MBuckyCarousel({ images, onCompleteSlide }: Props) {
    return (
        <React.Fragment>
            {images && images.length > 0 && (
                <Carousel
                    showThumbs={false}
                    onChange={onCompleteSlide}
                    infiniteLoop
                    autoPlay={false}
                    showIndicators={false}
                    showArrows={false}
                    swipeable={false}
                    showStatus={false}
                >
                    {images?.map((f, i) => {
                        return (
                            <div key={i}>
                                {f.url && <img src={f.url} alt="image" />}
                                {f.q && (
                                    <React.Fragment>
                                        <img src={marvel} alt="image" />
                                        <p className="legend">{f.q}</p>
                                    </React.Fragment>
                                )}
                            </div>
                        );
                    })}
                </Carousel>
            )}
        </React.Fragment>
    );
}
